import { GenericAbortSignal } from 'axios';
import { newApi } from './api.instance';

export class SearchApis {
  public static getMetaTags = async (
    by: 'compounds' | 'properties',
    body: any,
    language?: string
  ) => {
    return newApi({ ssrLocale: language })
      .get(`/v1/search/${by}/meta-tags`, { params: body })
      .then(({ data }) => data);
  };

  public static newCompoundsSearch = async (
    body: any,
    language?: string,
    options?: { signal?: GenericAbortSignal }
  ) => {
    return newApi({ ssrLocale: language })
      .get('/v1/search/compounds', {
        params: body,
        signal: options?.signal
      })
      .then(({ data }) => data);
  };
}
